import React from 'react';

import { useLoyaltyOffersUiLoggedInQuery } from 'generated/sanity-graphql';
import { maybeLocale } from 'utils/graphql';

import { EndOfOffers } from './end-of-offers';

const LoyaltyEndOfOffersLoggedIn = () => {
  const { data } = useLoyaltyOffersUiLoggedInQuery({
    variables: {
      id: 'feature-loyalty-offers-ui-singleton',
    },
  });
  const message = maybeLocale(data?.LoyaltyOffersUI?.endOfOffersLoggedIn?.endOfOffersMessage);
  const image = maybeLocale(data?.LoyaltyOffersUI?.endOfOffersLoggedIn?.endOfOffersImage);
  if (!message || !image) {
    return null;
  }
  return <EndOfOffers message={message || ''} image={image} />;
};

export default LoyaltyEndOfOffersLoggedIn;
